import request from "@/utils/request";

export function submit(data) {
  return request({
    url: "/NewStudent/Submit",
    method: "post",
    data
  });
}
export function getBaseInfo(params) {
  return request({
    url: "/NewStudent/GetBaseInfo",
    method: "get",
    params
  });
}
export function dateSupport(params) {
  return request({
    url: "/NewStudent/CanSupportPickUpService",
    method: "get",
    params
  });
}
export function timeSupport(params) {
  return request({
    url: "/NewStudent/CanSupportPickUpServiceBetweenTime",
    method: "get",
    params
  });
}
export function getDesc(params) {
  return request({
    url: "/NewStudent/GetSupportServiceNote",
    method: "get",
    params
  });
}
export function getPort(params) {
  return request({
    url: "/NewStudent/GetPortItemGroup",
    method: "get",
    params
  });
}
export function getResultNew(params) {
  return request({
    url: "/NewStudent/GetHostelApplicationResult",
    method: "get",
    params
  });
}
export function isCorrect(data) {
  return request({
    url: "/NewStudent/IsCorrect",
    method: "post",
    data
  });
}
